



























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
@Component({})
export default class DayRange extends Vue {
  @Prop({ type: Date, default: () => new Date() }) day!: Date;
  daynum = 1;

  @Watch("day")
  updateDate(): void {
    this.daynum = this.day.getDate();
  }

  changeMonth(step: number): void {
    const newmonth = this.day.getMonth() + step;
    const today = new Date();
    this.day.setMonth(newmonth);
    if (newmonth == today.getMonth()) this.day.setDate(today.getDate());
    else this.day.setDate(1);
    this.day = new Date(this.day);
  }

  today(): void {
    this.day = new Date();
  }

  @Watch("daynum")
  chandeDay(daynum: number): void {
    this.day.setDate(daynum);
    this.day = new Date(this.day);
  }

  mounted(): void {
    this.$nextTick(() => this.updateDate());
  }
}
